import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import css from "./Prose.module.css";

const Prose = React.forwardRef(
  ({ className, children, dangerouslySetInnerHTML, ...rest }, ref) => {
    const classes = clsx(css.prose, className);

    return (
      <div
        ref={ref}
        className={classes}
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        {...rest}
      >
        {dangerouslySetInnerHTML ? undefined : children}
      </div>
    );
  },
);

Prose.displayName = "Prose";

Prose.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  dangerouslySetInnerHTML: PropTypes.shape({ __html: PropTypes.string }),
};

export default Prose;
